import * as React from 'react'
import CircularProgress from '@mui/material/CircularProgress'
import * as Styled from './style'

const Loader = () => {
  return (
    <Styled.Container>
      <CircularProgress />
    </Styled.Container>
  )
}

export default Loader
